<template>
  <header>
    <div class="header">
      <div class="header-content">
        <div class="help-center">
          <h4>CENTRAL DE AJUDA</h4>
        </div>
        <div class="homepage-logo">
          <a :href="configs[$parent.site].url">
            <img
              :src="`${getImage(configs[$parent.site].logo)}`"
              :alt="configs[$parent.site].titulo"
              :title="configs[$parent.site].titulo"
            />
          </a>
        </div>
        <div class="menu">
          <a
            v-for="(menu_topo, index) in configs[$parent.site]['menu-topo']"
            :key="index"
            :href="menu_topo.url"
          >
            <img
              :src="`${getImage(menu_topo.image)}`"
              :alt="configs[$parent.site].titulo"
              :title="menu_topo.nome"
            />
          </a>
        </div>
      </div>
    </div>
    <div class="header-links">
      <div class="container">
        <ul>
          <li v-for="(link, index) in configs[$parent.site].menu" :key="index">
            <a :href="link.url">
              <span>{{ link.nome }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="hero"
      :style="{
        backgroundImage: `url(${isMobile() ? getImage(configs[$parent.site].heroMobile) : getImage(configs[$parent.site].hero)})`,
      }"
    >
      <div class="hero-inner d-flex flex-column justify-content-center">
        <h1 class="welcome-text">Olá, aqui você tem acesso rápido para</h1>
        <div class="links-container">
          <div class="container">
            <div class="row no-gutters">
              <div
                class="link-box col-6 col-md-6 col-lg-3"
                v-for="(box, index) in configs[$parent.site]['links-box']"
                :key="index"
              >
                <a
                  :href="box.link"
                  class="d-flex align-items-center justify-content-center flex-column w-100"
                >
                  <div>
                    <img :src="`${getImage(box.image)}`" :alt="box.nome" />
                  </div>
                  <h4>{{ box.nome }}</h4>
                  <span>{{ box.descricao }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<style lang="scss">
.header {
  background-color: #000;
  color: #fff;
  padding: 20px 0;
}

.header-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 50px;
  justify-content: space-between;
  .menu {
    a {
      align-items: center;
      justify-content: center;
      text-decoration: none;
      padding: 0 5px;
    }
  }
  .help-center {
    h4 {
      font-weight: 700;
      font-size: 15px;
      text-transform: uppercase;
      margin-bottom: 0;
      align-self: baseline;
    }
  }
}

.logo {
  margin: auto;
}

.header-links ul {
  width: 75%;
  overflow-x: auto;
  min-height: 45px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  padding: 0;
  margin: 0 auto;
  li {
    a {
      text-transform: uppercase;
      padding: 0px 5px;
    }
  }
  .hero {
    background-position: center;
    background-size: cover;
    text-align: center;
  }
}

@media (max-width: 767px) {
  .header-links ul {
    width: 100%;
  }
}

.link-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 15px;
  padding: 0 15px!important;
  a {
    background: #fff;
    color: #000;
    text-decoration: none;
    min-height: 180px;
    & h4 {
      color: #000;
      font-size: 14px;
      margin: 10px 0;
      text-decoration: none;
    }
    & span {
      color: #000;
      font-size: 12px;
      max-width: 90%;
      text-align: center;
    }
    & span:hover {
      text-decoration: underline;
    }
    &:hover {
      text-decoration: underline;
      color: #000;
    }
  }
}
.hero-inner {
  min-height: 465px;
  .welcome-text {
    text-transform: uppercase;
    font-weight: 400;
    color: #fff;
    font-size: 24px;
    text-shadow: 1px 1px 8px rgba(0, 0, 0, 1);
    margin: 20px auto;
  }
}

/*Breakpoint tablet */
@media (max-width: 768px) {
  .hero-inner .welcome-text {
    font-size: 24px;
  }
  .link-box {
    padding: 0 7.5px!important;
  }
}
/*Breakpoint mobile */
/*mobile L */
@media (max-width: 560px) {
  .hero-inner .welcome-text {
    font-size: 16px;
  }
  .menu {
    display: none;
  }
  .help-center {
    display: none;
  }
  .header-content {
    width: 100%;
    padding: 0;
    justify-content: center;
  }
  .lelis .hero-inner {
    min-height: 700px;
  }
  .hero-inner {
    min-height: 465px;
    .welcome-text {
      font-size: 16px;
    }
  }
}
/*mobile M*/
@media (max-width: 375px) {
  .homepage-logo img {
    max-width: 250px;
  }
}
/*mobile S*/
@media (max-width: 340px) {
  .homepage-logo img {
    max-width: 250px;
  }
}
</style>
<script>
import { configs } from '@/assets/data/data.json';
export default {
  name: 'Header',
  methods: {
    fetchData() {
      let categoryId = this.$route.params.categoryId;
      this.setup = configs[this.$parent.site];
      this.categoryId = categoryId;
    },
    getImage(image) {
      const icons = require.context(
        '../assets/',
        true,
        /\.(png|jpe?g|gif|svg)(\?.*)?$/
      );
      return image ? icons(`./${this.$parent.site}/${image}`) : '';
    },
    isMobile() {
      let check = false;
      // eslint-disable-next-line
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
  },
  created() {
    this.fetchData();
    this.isMobile();
  },
  data: function() {
    return {
      configs,
      site: '',
      setup: '',
    };
  },
};
</script>
